import React, { Component } from 'react';

import classNames from 'classnames';
import { inject } from 'mobx-react';
import PropTypes from 'prop-types';

import './DataTableDataColumns.scss';

@inject((stores) => ({
  isMobile: stores.UiStore.isMobile
}))
class DataTableDataColumns extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    isMobile: PropTypes.bool
  };

  render() {
    const { children, className, isMobile } = this.props;
    const classComponent = classNames('data-table-data-columns', className);

    if (!isMobile) {
      return children;
    }

    return <div className={classComponent}>{children}</div>;
  }
}

export default DataTableDataColumns;
